<template>
  <div>
    <v-btn icon small @click="dialog_ativo = true">
      <v-icon small>mdi-information-outline</v-icon>
    </v-btn>

    <SysDialogFullscreen v-model="dialog_ativo" transition="dialog-bottom-transition">
      <template #titulo>
        <v-btn icon class="ml-n2 mr-5" dark @click="dialog_ativo = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <span class="font-19">Detalhamento do Produto</span>
        <span class="font-13 ml-1 mt-3px">- {{ status_abastecimento === 'DISP DRP' ? 'DRP REVERSO' : 'DRP ABASTECIMENTO' }}</span>

        <v-spacer />

        <Legenda titulo="Visualização" :legenda="`Alterar para visão ${exibir_lado_a_lado ? 'individual' : 'lado a lado'}`">
          <v-btn icon dark @click="exibir_lado_a_lado = !exibir_lado_a_lado">
            <v-icon v-if="exibir_lado_a_lado" style="rotate: 180deg">$ViewGallery</v-icon>
            <v-icon v-else>mdi-view-column</v-icon>
          </v-btn>
        </Legenda>
      </template>

      <div ref="divOverflow" class="d-flex pt-1 pb-1 altura-card-detalhes-drp overflow-auto">
        <template v-if="exibir_lado_a_lado">
          <div
            v-for="(detalhes, key) in detalhes_produtos"
            :key="key"
            class=" elevation-3 mx-1 br-3px h-full px-1"
            :class="{ 'w-50-porcento' : !temOverflow, 'classe-overflow': temOverflow }"
          >
            <DetalhesProdutoFilialDrp :dados="detalhes" :idgrupo="$props.idgrupo" />

            <v-divider />

            <div class="mt-1" style="height: calc(82vh - 408px)">
              <GraficoMovimentacoesEstoqueProduto
                class="ml-n3 mt-n4"
                :qtde_meses_pai="qtde_meses"
                :produto="{grupo: idgrupo, filial: detalhes.filial, produto: String(idproduto)}"
                @update:qtde-meses="atualizarQtdeMeses"
              />
            </div>
          </div>
        </template>

        <template v-else>
          <v-tabs centered class="mt-n1">
            <template v-for="(detalhes, key) in detalhes_produtos">
              <v-tab :key="key">
                <template v-if="detalhes.descricao_hub">{{ detalhes.descricao_hub }} - </template>

                {{ `Filial ${detalhes.filial}` }}

                <template v-if="detalhes.descricao_filial">
                  {{ `- ${Helpers.primeiraLetraMaiuscula(detalhes.descricao_filial || '')}` }}
                </template>
              </v-tab>

              <v-tab-item :key="`${key}_`">
                <div class="mx-2 br-3px h-full px-1">
                  <DetalhesProdutoFilialDrp :dados="detalhes" :idgrupo="$props.idgrupo" />

                  <v-divider />

                  <div class="mt-1" style="height: calc(82vh - 408px)">
                    <GraficoMovimentacoesEstoqueProduto
                      class="ml-n3 mt-n4"
                      :qtde_meses_pai="qtde_meses"
                      :produto="{grupo: idgrupo, filial: detalhes.filial, produto: String(idproduto)}"
                      @update:qtde-meses="atualizarQtdeMeses"
                    />
                  </div>
                </div>
              </v-tab-item>
            </template>
          </v-tabs>
        </template>
      </div>
    </SysDialogFullscreen>
  </div>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen";
import DetalhesProdutoFilialDrp from "@/components/drp/separacaoDeMercadorias/DetalhesProduto/DetalhesProdutoFilialDrp";
import { buscarDetalhesProdutoDrp } from "@/api/drp";
import { logout } from "@/helpers";
import store from "@/store";
import Legenda from "@/components/produto/detalhes/Legenda";
import GraficoMovimentacoesEstoqueProduto from "@/components/produto/detalhes/grafico/GraficoMovimentacoesEstoqueProduto.vue";

export default {
  name: "DetalhesProdutoDrp",
  components: {
    GraficoMovimentacoesEstoqueProduto,
    Legenda,
    DetalhesProdutoFilialDrp,
    SysDialogFullscreen
  },
  props: {
    idgrupo: Number,
    filial_destino: Number,
    filial_origem: Number,
    idproduto: [Number, String],
    status_abastecimento: String,
  },
  setup(props) {
    const dialog_ativo = ref(false);
    const exibir_lado_a_lado = ref(true);
    const detalhes_produtos = ref([]);

    const temOverflow = ref(false);
    const divOverflow = ref(null);
    let observadorResize = null;
    const windowWidth = ref(window.innerWidth);
    const windowWidthFix = window.innerWidth;
    const handleResize = () => windowWidth.value = window.innerWidth;

    const verificarOverflow = () => {
      const elemento = divOverflow.value;

      if (elemento) {
        if (elemento.childNodes && elemento.childNodes[0] != undefined && windowWidthFix != windowWidth.value) {
          temOverflow.value = elemento.scrollWidth > 800;
        } else {
          temOverflow.value = false;
        }        
      }
    };

    watch(detalhes_produtos, verificarOverflow);
    watch(() => windowWidth.value, () => verificarOverflow());

    const buscarDetalhesProduto = () => {
      const parametros = {
        idgrupo: props.idgrupo,
        filial_destino: props.filial_destino,
        filial_origem: props.filial_origem,
        idproduto: props.idproduto,
        status_abastecimento: props.status_abastecimento,
      };

      store.dispatch('loading/addRequisicao',
        buscarDetalhesProdutoDrp(parametros)
          .then(detalhes => {
            detalhes_produtos.value = detalhes;
            verificarOverflow();
          })
          .catch(logout)
      );
    };

    watch(dialog_ativo, valor => {
      verificarOverflow();
      if (valor) {
        buscarDetalhesProduto();
      } else {
        detalhes_produtos.value = [];
      }
    });

    onMounted(() => {
      verificarOverflow();
      const elemento = divOverflow.value;
      if (elemento) {
        observadorResize = new ResizeObserver(() => verificarOverflow());
        observadorResize.observe(elemento);
      }
      window.addEventListener('resize', handleResize);
    });

    const qtde_meses = ref(12);

    function atualizarQtdeMeses(novo_qtde) {
      qtde_meses.value = novo_qtde;
    }

    return {
      dialog_ativo,
      exibir_lado_a_lado,
      detalhes_produtos,
      temOverflow,
      divOverflow,
      qtde_meses,
      atualizarQtdeMeses
    };
  },
};
</script>

<style>
.altura-card-detalhes-drp {
  height: calc(100vh - 62px);
}

.classe-overflow {
  width: 800px !important;
}
</style>
